import { render } from "./AddRes.vue?vue&type=template&id=6db1de1a"
import script from "./AddRes.vue?vue&type=script&lang=js"
export * from "./AddRes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__